import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

import LoadingPage from '@/common/pages/LoadingPage';
import useAddDamagedPerson from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/hooks/useAddDamagedPerson';
import AddDamagedPersonModal from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/modals/AddDamagedPersonModal';
import ParticipantCard from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCard/ParticipantCard';
import ParticipantCardWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardWrapper/ParticipantCardWrapper';
import { participantsIncidentQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/participantsIncidentQueryOptions';
import { useParticipantsStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/participantsStore';
import { useEffect } from 'react';

const InformationDamagedList = () => {
  const { id } = useParams();
  const { setCulpritStoreId } = useParticipantsStore();
  const { data, isError, isPending } = useQuery(
    participantsIncidentQueryOptions({ id: id! }),
  );

  useEffect(() => {
    if (data?.damages[0]?.id) setCulpritStoreId(data.damages[0].id);
  }, [data, setCulpritStoreId]);

  const { modal, addDamagedPerson } = useAddDamagedPerson();
  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }
  return (
    <Box pt="1rem">
      <ParticipantCardWrapper
        addDamagedPerson={addDamagedPerson}
        length={data.damages.length}
      >
        {data.damages?.map((item, index) => (
          <ParticipantCard
            state="information"
            type="damaged"
            key={index}
            file={item}
            index={+`${index + 1}`}
            damagedType={item?.damaged_type?.const}
          />
        ))}
      </ParticipantCardWrapper>

      <AddDamagedPersonModal closeModal={modal.closeModal} open={modal.open} />
    </Box>
  );
};
export default InformationDamagedList;
